<template>
  <div class="fill-height">
    <div
      v-for="(dataItem, i) in data"
      :key="i"
    >
      <v-row v-if="dataItem.length > 0">
        <v-col cols="12">
          <v-card class="mx-auto">
            <v-card-title>
              <h1 class="mb-5">
                {{ $vuetify.lang.t(`$vuetify.sidebar.${i}`) }}
              </h1>
            </v-card-title>
            <v-row>
              <v-col
                v-for="(item, j) in dataItem"
                :key="j"
                cols="12"
                sm="6"
                md="4"
                xl="3"
              >
                <template v-if="item.children">
                  <h2 class="text-center text--secondary mb-3">
                    {{ item.text }}
                  </h2>
                  <v-row>
                    <v-col
                      v-for="(childItem, k) in item.children"
                      :key="k"
                      cols="12"
                    >
                      <v-card
                        max-width="300"
                        hover
                        class="mx-auto grey lighten-3"
                        :to="childItem.link"
                      >
                        <v-card-title>
                          <v-icon
                            large
                            class="mr-2"
                          >
                            {{ childItem.icon }}
                          </v-icon>
                          <div class="font-weight-medium text-center">
                            {{ childItem.text }}
                          </div>
                        </v-card-title>
                      </v-card>
                    </v-col>
                  </v-row>
                </template>
                <template v-else>
                  <v-card
                    max-width="300"
                    hover
                    class="mx-auto grey lighten-3"
                    :to="item.link"
                  >
                    <v-card-title>
                      <v-icon
                        large
                        class="mr-2"
                      >
                        {{ item.icon }}
                      </v-icon>
                      <div class="font-weight-medium text-center">
                        {{ item.text }}
                      </div>
                    </v-card-title>
                  </v-card>
                </template>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>

export default {
  data: () => {
    return {
      data: {
        general: [],
        features: [],
        views: [],
        settings: [],
      },
    };
  },
  created() {
    const general = [];
    const features = [];
    const views = [];
    const settings = [];

    // General
    if (this.$store.state.user.permissions.indexOf(2) >= 0) {
      general.push(
        { icon: 'mdi-robot-industrial', text: this.$vuetify.lang.t('$vuetify.sidebar.machine'), link: '/machine' },
      );
    }
    if (this.$store.state.user.permissions.indexOf(3) >= 0) {
      general.push(
        { icon: 'mdi-chip', text: this.$vuetify.lang.t('$vuetify.sidebar.dataController'), link: '/datacontroller' },
      );
    }

    // Features
    if (this.$store.state.user.permissions.indexOf(6) >= 0) {
      features.push(
        {
          icon: 'mdi-chevron-up',
          'icon-alt': 'mdi-chevron-down',
          text: this.$vuetify.lang.t('$vuetify.sidebar.weavingMachine.title'),
          model: false,
          children: [
            { icon: 'mdi-cog', text: this.$vuetify.lang.t('$vuetify.sidebar.weavingMachine.settings'), link: '/weaving-machine/settings' },
            { icon: 'mdi-chart-bar', text: this.$vuetify.lang.t('$vuetify.sidebar.weavingMachine.statistics'), link: '/weaving-machine/statistics' },
          ],
        },
      );
    }

    if (this.$store.state.user.permissions.indexOf(7) >= 0) {
      features.push(
        {
          icon: 'mdi-chevron-up',
          'icon-alt': 'mdi-chevron-down',
          text: this.$vuetify.lang.t('$vuetify.sidebar.machineStats.title'),
          model: false,
          children: [
            { icon: 'mdi-monitor-dashboard', text: this.$vuetify.lang.t('$vuetify.sidebar.machineStats.overview'), link: '/stat/overview' },
            { icon: 'mdi-file-table-box-multiple', text: this.$vuetify.lang.t('$vuetify.sidebar.machineStats.summarize'), link: '/stat/summarize' },
            { icon: 'mdi-chart-areaspline-variant', text: this.$vuetify.lang.t('$vuetify.sidebar.machineStats.statistics'), link: '/stat/graph' },
            { icon: 'mdi-timer', text: this.$vuetify.lang.t('$vuetify.sidebar.machineStats.realtime'), link: '/stat/graph-realtime' },
          ],
        },
      );
    }

    if (this.$store.state.user.permissions.indexOf(9) >= 0) {
      features.push(
        {
          icon: 'mdi-chevron-up',
          'icon-alt': 'mdi-chevron-down',
          text: this.$vuetify.lang.t('$vuetify.sidebar.annotations.title'),
          model: false,
          children: [
            { icon: 'mdi-cog', text: this.$vuetify.lang.t('$vuetify.sidebar.annotations.settings'), link: '/annotation/settings' },
            { icon: 'mdi-file-table-box-multiple', text: this.$vuetify.lang.t('$vuetify.sidebar.annotations.form'), link: '/annotation/form' },
          ],
        },
      );
    }

    // Views
    if (this.$store.state.user.permissions.indexOf(6) >= 0 || this.$store.state.user.permissions.indexOf(7) >= 0) {
      const data = {
        icon: 'mdi-chevron-up',
        'icon-alt': 'mdi-chevron-down',
        text: this.$vuetify.lang.t('$vuetify.sidebar.fullscreenStatistics.title'),
        model: false,
        children: [],
      };
      if (this.$store.state.user.permissions.indexOf(6) >= 0) {
        data.children.push({ icon: 'mdi-chart-bar', text: this.$vuetify.lang.t('$vuetify.sidebar.fullscreenStatistics.weavingMachine'), link: '/full-views/weaving-machine/statistics' });
      }
      if (this.$store.state.user.permissions.indexOf(7) >= 0) {
        data.children.push({ icon: 'mdi-monitor-dashboard', text: this.$vuetify.lang.t('$vuetify.sidebar.fullscreenStatistics.overview'), link: '/full-views/stat/overview' });
      }
      views.push(data);
    }

    // Settings
    if (this.$store.state.user.permissions.indexOf(1) >= 0 || this.$store.state.user.permissions.indexOf(5) >= 0) {
      const data = {
        icon: 'mdi-chevron-up',
        'icon-alt': 'mdi-chevron-down',
        text: this.$vuetify.lang.t('$vuetify.sidebar.management.title'),
        model: false,
        children: [],
      };
      if (this.$store.state.user.permissions.indexOf(1) >= 0) {
        data.children.push({ icon: 'mdi-account-multiple', text: this.$vuetify.lang.t('$vuetify.sidebar.management.users'), link: '/manage/user' });
      }
      if (this.$store.state.user.permissions.indexOf(5) >= 0) {
        data.children.push({ icon: 'mdi-account-group', text: this.$vuetify.lang.t('$vuetify.sidebar.management.groups'), link: '/manage/group' });
      }
      settings.push(data);
    }

    this.data.settings = settings;
    this.data.general = general;
    this.data.views = views;
    this.data.features = features;
  },
};
</script>
